import css from './index.module.scss';
import { createEFPic } from '@/utils/useEFPic';
import NextImage from '@/components/NextImage';
import { useLang } from '@/i18n';
import { useGlobal } from '@/utils/useGlobal';

const asset = '/media/community/pc/';
const { EFPic } = createEFPic(asset);

export default function Products() {
    const { t } = useLang('communitylang.products');
    const { Link } = useGlobal();

    const productsData = [
        {
            key: 2,
            name: t('tab_1.name_2'),
            img: ['product_2.jpg', 'product_2.jpg'],
            url: 'https://bit.ly/3IzFhPJ',
        },
        {
            key: 3,
            name: t('tab_1.name_3'),
            img: ['product_3.jpg', 'product_3.jpg'],
            url: 'https://bit.ly/42068eG',
        },
        {
            key: 4,
            name: t('tab_1.name_4'),
            img: ['product_4.jpg', 'product_4.jpg'],
            url: 'https://bit.ly/3MpyEAJ',
        },
        {
            key: 5,
            name: t('tab_1.name_5'),
            img: ['product_5.jpg', 'product_5.jpg'],
            url: 'https://bit.ly/3BN8wL4',
        },
    ];

    return (
        <div className={`products ${css.products}`}>
            <div className="products-content">
                <p className="title">{t('title')}</p>
                <p className="desc">{t('desc')}</p>
            </div>
            <div className="products-box">
                <div className="product-item">
                    <Link
                        href="https://bit.ly/430SN7e"
                        ariaLabel={t('join')}
                        dataLayer={{
                            event: 'uaEvent',
                            event_name: 'community_button',
                            list_name: t('title'),
                            button_name: t('join'),
                        }}
                    >
                        <div className="product-img">
                            <NextImage src={require('@publicLocal/community/pc/product_1.jpg')} />
                        </div>
                    </Link>

                    <p className="item-name">{t('tab_1.name_1')}</p>
                    <div className="join-btn">
                        <Link
                            href="https://bit.ly/430SN7e"
                            ariaLabel={t('join')}
                            dataLayer={{
                                event: 'uaEvent',
                                event_name: 'community_button',
                                list_name: t('title'),
                                button_name: t('join'),
                            }}
                        >
                            <p className="btn-text">{t('join')}</p>
                        </Link>
                    </div>
                </div>
                <div className="flex-box">
                    {productsData.map((product, index) => (
                        <div key={product.key} className="product-item-flex">
                            <Link
                                href={product.url}
                                ariaLabel={t('join')}
                                dataLayer={{
                                    event: 'uaEvent',
                                    event_name: 'community_button',
                                    list_name: t('title'),
                                    button_name: t('join'),
                                }}
                            >
                                <EFPic className="product-img" name={product.img} />
                            </Link>
                            <p className="item-name">{product?.name}</p>
                            <div className="join-btn">
                                <Link
                                    href={product.url}
                                    ariaLabel={t('join')}
                                    dataLayer={{
                                        event: 'uaEvent',
                                        event_name: 'community_button',
                                        list_name: t('title'),
                                        button_name: t('join'),
                                    }}
                                >
                                    <p className="btn-text">{t('join')}</p>
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
